export const sliceKey = 'catalogueData';
